import { PageShell } from "@/components/PageShell";
import { Overline } from "@/components/Reveal";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  return (
    <PageShell>
      <section className="relative min-h-[70vh] flex items-center pt-36 pb-28">
        <div className="absolute inset-0 grid-lines opacity-40 pointer-events-none" />
        <div className="relative mx-auto max-w-[1100px] px-6 md:px-10">
          <Overline>Erro 404</Overline>
          <h1 className="font-display font-extrabold text-6xl md:text-8xl tracking-tighter mt-6">
            Página não encontrada.
          </h1>
          <p className="text-neutral-400 text-lg mt-6 max-w-[48ch]">
            O endereço acessado não existe ou foi movido. Volte para a página
            inicial da RODE IA.
          </p>
          <a
            href="/"
            data-testid="notfound-home-link"
            className="group mt-10 inline-flex items-center gap-2 border border-white/20 text-white font-medium px-7 py-4 rounded-sm hover:border-white/50 hover:bg-white/5 active:scale-95 transition-all"
          >
            <ArrowLeft className="h-4 w-4 group-hover:-translate-x-1 transition-transform" />
            Voltar ao início
          </a>
        </div>
      </section>
    </PageShell>
  );
};

export default NotFound;
